import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  PayCampaign,
  GenericResponse,
  PayHealthcarepackage,
  PayTopUp,
  PayBenefit,
} from '../../models/models';

@Injectable()
export class PaymentService {
  protected basePath = environment.basePath;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(private http: HttpClient) {}

  /**
   * Pay Campaign
   * Buy multiple healthpackages for a campaign
   * @param body
   */
  public payCampaign(body?: PayCampaign): Observable<GenericResponse> {
    return this.http.post<GenericResponse>(
      `${this.basePath}/v1/pay/campaign`,
      body,
      this.httpOptions
    );
  }

  /**
   * Pay Healthpackage
   * @param body
   */
  public payHealthPackage(
    body?: PayHealthcarepackage,
    isWhiteLabel: boolean = false
  ): Observable<any> {
    const apiEndpoint = isWhiteLabel
      ? 'label_pay_healthpackages'
      : 'healthpackages';
    return this.http.post<any>(
      `${this.basePath}/v1/pay/${apiEndpoint}`,
      body,
      this.httpOptions
    );
  }

  /**
   * Pay TopUp
   * @param body
   */
  public payTopUp(body?: PayTopUp): Observable<any> {
    return this.http.post<any>(
      `${this.basePath}/v1/pay/topup`,
      body,
      this.httpOptions
    );
  }

  /**
   * Pay TopBenefit
   * @param body
   */
  public payBenefit(body: PayBenefit, group_id: number): Observable<any> {
    return this.http.post<any>(
      `${this.basePath}/v1/pay/transfert_credits/${group_id}`,
      body,
      this.httpOptions
    );
  }

  /**
   * Cancel payment
   * @param body
   */
  public cancelPayment(paymentId: number): Observable<any> {
    return this.http.post<any>(
      `${this.basePath}/v1/pay/cancel/${paymentId}`,
      this.httpOptions
    );
  }

  /**
   * close cash payment
   * @param body
   */
  public closeCashPayment(
    paymentId: number,
    body: { cash_status: string }
  ): Observable<any> {
    return this.http.put<any>(
      `${this.basePath}/v1/pay/update-cash/${paymentId}`,
      JSON.stringify(body),
      this.httpOptions
    );
  }
}
